<template>
  <div class="msg-pure-text">
    <div ref="msgTxt"  v-if="translateContent" v-html="processedText"></div>
    <div class="translate-bottom">{{ translateType }}<div class="translate-icon"></div></div>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import b2cTextMsgTranslate from  '@/utils/translateMsg';

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      translateContent: '',
      translateType: '',
      processedText: '',
    };
  },
  computed: {
    processedText() {
      // 过滤html，仅保留 a ；
      let text = Utils.filterHTML(this.data.content);
      text = Utils.emojiEscape(text);
      // 当文本中不包括 a连接时，才进行转发
      return text;
    },
  },
  async mounted() {
    const tranlateMsgRes = await b2cTextMsgTranslate(this.data.content).catch(() => {
      this.translateContent = '';
      this.translateType = '';
      this.processedText = '';
    });
    if (!tranlateMsgRes) {
      this.translateContent = '';
      this.translateType = '';
      this.processedText = '';
      return;
    }
    switch (tranlateMsgRes.type) {
      case 'success': {
        this.translateType = this.$t('common_tencent_translator');
        break;
      };
      case 'fail': {
        this.translateType = this.$t('common_tencent_translator_fail');
        break;
      };
      case 'fail': {
        this.translateType = this.$t('common_tencent_translator_only');
        break;
      };
      default: {
        this.translateType = '';
      }
    };
    this.translateContent = tranlateMsgRes.targetText;
  },
  methods: {
    // 处理<a>的点击
  },
};
</script>

<style lang="less" scoped>
// 文本消息样式
.msg-pure-text {
  font-family: @emoji-family, "PingFangSC-Regular", "Microsoft YaHei",
    "sans-serif";
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  padding: 10px 15px;
  max-width: 300px;

  .emoji {
    font-size: 20px;
    vertical-align: -2px;
  }

  &.pc{
    font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  &.pc.pc-not-frame{
     max-width: 460px;
  }
}

// 处理c2b消息文字颜色
.msg-c2b{
  .msg-pure-text{
    color: #fff;
    ::v-deep a{
      color: #fff;
    }
  }
}
</style>
